// used for deep linking, when token refresh is needed
let resolveAuthReady: (value: boolean | PromiseLike<boolean>) => void;
export const authReady = new Promise<boolean>((resolve) => {
  resolveAuthReady = resolve;
});

let isAuthReady = false;
export const setIsAuthReady = () => {
  if (!isAuthReady) {
    isAuthReady = true;
    resolveAuthReady?.(isAuthReady);
  }
};
